import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M22.9 9H11.65a.25.25 0 0 1-.23-.15.25.25 0 0 1 .05-.27l3.34-3.37a1 1 0 0 0 0-1.39L12 1.08a1 1 0 0 0-1.42 0L.4 11.29a1 1 0 0 0 0 1.42l10.21 10.21a1 1 0 0 0 1.42 0l2.75-2.75a1 1 0 0 0 0-1.4l-3.29-3.35a.25.25 0 0 1 .18-.42H22.9a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1"
    }, null, -1)
  ]));
}
const arrowLeft = { render };
export {
  arrowLeft as default,
  render
};
//# sourceMappingURL=arrow-left.svg.js.map
